import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import CheckCircle from 'dibs-icons/exports/CheckCircle';
import classnames from 'classnames';
import { useCoreBuyerIncentives } from 'dibs-buyer-incentives/exports/useCoreBuyerIncentives';

import dibsCss from 'dibs-css';

import { BuyerIncentives_viewer$key } from './__generated__/BuyerIncentives_viewer.graphql';
import { BuyerIncentives_item$key } from './__generated__/BuyerIncentives_item.graphql';
import { BuyerIncentives_buyer$key } from './__generated__/BuyerIncentives_buyer.graphql';

const viewerFragment = graphql`
    fragment BuyerIncentives_viewer on Viewer {
        ...useCoreBuyerIncentives_viewer @arguments(userCountryCode: $userCountryCode)
    }
`;

const itemFragment = graphql`
    fragment BuyerIncentives_item on Item {
        ...useCoreBuyerIncentives_item
            @arguments(userCountryCode: $userCountryCode, userId: $buyerId)
    }
`;

const buyerFragment = graphql`
    fragment BuyerIncentives_buyer on User {
        ...useCoreBuyerIncentives_user @arguments(isTrade: $hasTradeStatus)
    }
`;

export const BuyerIncentives: FC<{
    viewer: BuyerIncentives_viewer$key;
    item: BuyerIncentives_item$key;
    buyer: BuyerIncentives_buyer$key | null;
    incentiveClassName?: string;
    iconWrapperClassName?: string;
}> = ({
    viewer: viewerRef,
    item: itemRef,
    buyer: buyerRef,
    incentiveClassName,
    iconWrapperClassName = dibsCss.fillShagreen700,
}) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const item = useFragment(itemFragment, itemRef);
    const user = useFragment(buyerFragment, buyerRef);

    const incentives = useCoreBuyerIncentives({ viewer, item, user });

    return (
        <>
            {incentives.map((incentive, index) => (
                <div
                    key={index}
                    className={classnames(
                        dibsCss.flex,
                        dibsCss.gapXsmall,
                        dibsCss.itemsCenter,
                        incentiveClassName
                    )}
                >
                    <span className={iconWrapperClassName}>
                        <CheckCircle variation="20Filled" />
                    </span>
                    {incentive}
                </div>
            ))}
        </>
    );
};
